import React, {Component} from 'react';
import 'react-multi-carousel/lib/styles.css';
import '../assets/golf-course-detail.css'
import Button from '@material-ui/core/Button';
import {withNamespaces} from 'react-i18next';
import Weather from '../components/weather';
import i18n from '../i18n'
import Rating from '@material-ui/lab/Rating';
import GolfClubWeb from '../pages/golf-clup-web';
import httpRequest from '../components/request-api'
import { ScrollMenu } from 'react-horizontal-scrolling-menu'
import ImagesViewer from 'react-images-viewer'

const _ = require('lodash');

class GolfCourseDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            teeoff: [],
            togglePage: true,
            dataForGolfClub: {},
            service_id: [],
            galleries: [],
            isOpen: false,
            currImg: 0,
        }
        this.changeLanguage(this.props.match.params.lang)

        this.gotoNext = this.gotoNext.bind(this)
        this.gotoPrev = this.gotoPrev.bind(this)
        this.gotoImg = this.gotoImg.bind(this)
    }

    changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    componentDidMount() {
        this.renderData(this.props.match.params.id)
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    renderData = async (courseCode) => {
        await httpRequest.fetchTeeoff(courseCode).then(result => {
            this.setState({
                service_id: result.data.result.data.service_id,
                galleries: result.data.result.data.galleries,
                data: result.data.result.data,
                teeoff: _.chain(result.data.result.data.teeoff_id).groupBy("teeoff_code").map((value, key) => ({
                    teeoff_code: key,
                    teeoff_group: value
                })).value()
            })
        }).catch(error => {
            console.log(error);
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.renderData(nextProps.match.params.id)
            this.setState({
                togglePage: true
            })
        }
    }

    selectId(id) {
        this.props.history.push(`/golf-course-detail/${id}/${localStorage.getItem("i18nextLng")}`)
    }

    escapeRegExp(string) {
        return string.split(/(\(.*\))/);
    }

    teeOffGender(gender) {
        switch (gender) {
            case 'm':
                return i18n.t('men')
            case 'f':
                return i18n.t('women')
            default:
                return ' - '
        }
    }

    openImagesViewer (index, event) {
        event.preventDefault()

        this.setState({
            currImg: index,
            isOpen: true,
        })
    }

    closeImagesViewer () {
        this.setState({
            currImg: 0,
            isOpen: false,
        })
    }

    gotoPrev () {
        this.setState({
            currImg: this.state.currImg - 1
        })
    }

    gotoNext () {
        this.setState({
            currImg: this.state.currImg + 1
        })
    }

    gotoImg (index) {
        this.setState({
            currImg: index
        })
    }

    render() {
        const {data, teeoff, togglePage, dataForGolfClub, service_id, galleries, currImg, isOpen} = this.state

        const {t, history} = this.props;
        const setName = (item) => {
            if (this.props.lng === "th") {
                return `${item.name_th !== "-" ? item.name_th : item.name_en}`
            } else if (this.props.lng === "en") {
                return `${item.name_en !== "-" ? item.name_en : item.name_th}`
            }
        };
        const handleClick = (dataForGolfClub) => {
            this.setState({
                togglePage: !togglePage,
                dataForGolfClub: dataForGolfClub
            })
        };
        return (
            <div id="app">
                {!togglePage ? <GolfClubWeb selectId={this.selectId.bind(this)} history={history} name={setName(data)}
                                            dataForGolfClub={dataForGolfClub} handleClick={handleClick.bind(this)}/> :
                    <main>
                        <div className="slider-area">
                            <div className="slider-active single-slider slider-height d-flex align-items-center"
                                 style={{
                                     "backgroundImage": `url(${data.course_photo === false ? '/assets/img/default-empty-golf-field.jpg' : `data:image/png;base64,${data.course_photo}`}`,
                                     minHeight: '240px',
                                     position: 'relative',
                                }}>
                                {
                                    data['teeoff_measure'] ? <img src="/assets/img/check.png" className="golf-course-detail-check"/> : null
                                }
                                <div className="container">
                                    <div className="single-slider d-flex align-items-center">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="hero__caption">
                                                    <h3 data-animation="fadeInUp" data-delay=".6s" style={{
                                                        color: "#ffffff",
                                                        width: "100%",
                                                        textShadow: "2px 2px 8px #000000"
                                                    }}>{setName(data)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="about-area section-paddingt30 pt-2 pb-5">
                            {teeoff.map((item, index) => {
                                const yardage = item.teeoff_group[0].yardage
                                const description = item.teeoff_group[0].description

                                return (
                                    <div className="container pt-4" key={index}>
                                        <div>
                                            <h5 style={{float: "left"}}
                                                className="blue">{t('teeBox')} {this.escapeRegExp(item.teeoff_group[0].display_name)[0]}</h5>
                                            <Button style={{float: "right", textTransform: "none"}} className="mb-2"
                                                    variant="contained" color="primary"
                                                    onClick={() => handleClick(item.teeoff_group[0])}> {yardage > 0 ? `Yardage ${yardage}` : description}
                                                <i className="ti-angle-right ml-2 icon-cente"></i></Button>
                                        </div>
                                        <table style={{width: '100%'}}>
                                            <tbody style={{border: "1px solid #dddddd"}}>
                                            <tr style={{border: "1px solid #dddddd"}}>
                                                <th className="blue"
                                                    style={{border: "1px solid #dddddd"}}>{t('gender')}</th>
                                                <th className="blue">{t('yard')}</th>
                                                <th className="blue">{t('course')}</th>
                                                <th className="blue">{t('slope')}</th>
                                            </tr>
                                            {item.teeoff_group.map((data, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <th style={{borderRight: "1px solid #dddddd"}}>{this.teeOffGender(data['sex'])}</th>
                                                        <td>{data.yardrate}</td>
                                                        <td>{data.courserate}</td>
                                                        <td>{data.sloprate}</td>
                                                    </tr>
                                                );
                                            })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            })
                            }
                        </section>
                        <section className="section-paddingt30 pt-2">
                            <div className="container">
                                <h5 className="text-left blue">{t('contact')}</h5>
                                <div className="border-card text-left b-0" style={{background: "#F5F9FC"}}>
                                    <p className="mb-0"><span
                                        className="contact fontWeight blue">{t('phoneNumber')}</span> <span
                                        className="pl-2 black"> {data.phone ? data.phone : "N/A"}</span></p>
                                    <p className="mb-0"><span className="contact fontWeight blue">{t('address')}</span>
                                        <span className="pl-2 black">{data.address ? data.address : "N/A"}</span></p>
                                </div>
                            </div>
                        </section>
                        {
                            data && data.province && data.province.length === 2
                            ?  <section className="services-area section-paddingt30 pt-2">
                                    <div className="container">
                                        <h5 className="text-left blue">{t('weatherForecast')}</h5>
                                        <Weather province={data.province[1]}/>
                                    </div>
                                </section>
                            : <div></div>
                        }

                        <section className="services-area section-paddingt30 pt-2">
                            <div className="container">
                                <h5 className="text-left blue">{t('golfService')}</h5>
                                <ul className="ml-3">
                                    {service_id.length !== 0 ?
                                        <>
                                            {service_id.map((item) => (

                                                <li className="text-left">
                                                    <i className="fas  fa-circle mr-2"/> <span
                                                    className="fontWeight">{setName(item)}</span>
                                                </li>
                                            ))}
                                        </> : <li className="text-left">
                                            <i className="fas  fa-circle mr-2"/> <span
                                            className="fontWeight">{t('notService')}</span>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </section>
                        <section className="services-area section-paddingt30 pt-2">
                            <div className="container">
                                <h5 className="text-left blue">{t('gallery')}</h5>
                                {galleries.length > 0 ? <ScrollMenu>
                                    {galleries.map((gallery, i) => {
                                        const src = `data:image/png;base64, ${gallery['photo']}`

                                        return (<a href={src} key={i} onClick={(e) => this.openImagesViewer(i, e)}>
                                            <img src={src} height="200" className={'mr-3 rounded'}/>
                                        </a>)
                                    })}
                                </ScrollMenu> : <li className="text-left ml-3">
                                    <i className="fas fa-circle mr-2"/> <span
                                    className="fontWeight">{t('noGallery')}</span>
                                </li>}
                                <ImagesViewer
                                    imgs={galleries.map((gallery) => ({src: `data:image/png;base64, ${gallery['photo']}`}))}
                                    currImg={currImg}
                                    isOpen={isOpen}
                                    onClickNext={this.gotoNext}
                                    onClickPrev={this.gotoPrev}
                                    onClickThumbnail={this.gotoImg}
                                    onClose={() => this.closeImagesViewer()}
                                    backdropCloseable
                                    showThumbnails
                                />
                            </div>
                        </section>
                        <section className="services-area section-paddingt30 pt-2" style={{"marginBottom": "7rem"}}>
                            <div className="container">
                                <h5 className="text-left blue">{t('rating')}</h5>
                                <ul className="ml-3">
                                    <li className="text-left color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">1. {t('courseOverview')}</p>
                                        <Rating name="half-rating"
                                                value={data.satisfaction ? data.satisfaction.satisfaction_1.value : 0}
                                                precision={0.5} readOnly className="col-3"
                                                style={{"justifyContent": "center", marginLeft: "-28px"}}/>
                                    </li>
                                    <li className="text-left color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">2. {t('puttingGreen')} </p>
                                        <Rating name="half-rating"
                                                value={data.satisfaction ? data.satisfaction.satisfaction_2.value : 0}
                                                precision={0.5} readOnly className="col-3"
                                                style={{"justifyContent": "center", marginLeft: "-28px"}}/>
                                    </li>
                                    <li className="text-left color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">3. {t('service')}</p>
                                        <Rating name="half-rating"
                                                value={data.satisfaction ? data.satisfaction.satisfaction_3.value : 0}
                                                precision={0.5} readOnly className="col-3"
                                                style={{"justifyContent": "center", marginLeft: "-28px"}}/>
                                    </li>
                                    <li className="text-left color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">4. {t('clubHouse')}</p>
                                        <Rating name="half-rating"
                                                value={data.satisfaction ? data.satisfaction.satisfaction_4.value : 0}
                                                precision={0.5} readOnly className="col-3"
                                                style={{"justifyContent": "center", marginLeft: "-28px"}}/>
                                    </li>
                                    <li className="text-left color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">5. {t('valueOfMoney')}</p>
                                        <Rating name="half-rating"
                                                value={data.satisfaction ? data.satisfaction.satisfaction_5.value : 0}
                                                precision={0.5} readOnly className="col-3"
                                                style={{"justifyContent": "center", marginLeft: "-28px"}}/>
                                    </li>
                                    <li className="text-left color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">6. {t('satisfaction')}</p>
                                        <Rating name="half-rating"
                                                value={data.satisfaction ? data.satisfaction.satisfaction_6.value : 0}
                                                precision={0.5} readOnly className="col-3"
                                                style={{"justifyContent": "center", marginLeft: "-28px"}}/>
                                    </li>
                                    <div style={{"borderBottom": "0.5px solid #dddddd"}} className="pt-2"></div>
                                    <li className="text-left pt-2 color-text-header row">
                                        <p className="col-9 fontWeight mb-0 black">7. {t('willYouComeBackAgain')}</p>
                                        <span className="col-3 fontWeight text-center" style={{
                                            "color": "#ffb400",
                                            marginLeft: "-28px"
                                        }}> {data.satisfaction ? data.satisfaction.satisfaction_7.value : "N/A"}%</span>
                                    </li>
                                    <div style={{"borderBottom": "0.5px solid #dddddd"}} className="pt-2"></div>
                                </ul>
                            </div>
                        </section>
                    </main>
                }
            </div>

        );
    }
}

export default withNamespaces()(GolfCourseDetail);
